import React from "react";
import "./Legal.scss";

const CookiesPolicy = () => (
    <main className="legal-page">
        <h1>Cookies Policy</h1>
        <p><strong>Last updated:</strong> October 30, 2025</p>

        <h2>1. What Are Cookies?</h2>
        <p>
            Cookies are small text files stored on your device when you visit a website. They help us improve your browsing experience by remembering your preferences and understanding how you interact with our site.
        </p>

        <h2>2. How We Use Cookies</h2>
        <ul>
            <li><strong>Essential Cookies:</strong> Required for the website to function properly.</li>
            <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website.</li>
            <li><strong>Functional Cookies:</strong> Remember user preferences and improve usability.</li>
        </ul>

        <h2>3. Managing Cookies</h2>
        <p>
            You can control or delete cookies through your browser settings. Most browsers allow you to block or delete cookies, though some site features may not function properly without them.
        </p>

        <h2>4. Third-Party Services</h2>
        <p>
            We may use third-party tools such as Google Analytics, which may set their own cookies. These tools help us monitor website performance and improve user experience.
        </p>

        <h2>5. Changes to This Policy</h2>
        <p>
            We may update this Cookies Policy occasionally to reflect changes in technology or regulations.
        </p>
    </main>
);

export default CookiesPolicy;
